import { useEffect, useState } from 'react';
import { View } from 'react-native';

import Card from '@/components/ui/therapist/Card';
import { getSessions } from '@/stores/auth/services';

import {
  Session,
  SessionsList,
} from '@/components/SharedComponents/SessionsList';
import store from '@/stores/store';
import { Header } from '@/components/AccountHeader';
import { Management } from './Management';
import { PersonalInfo } from './PersonalInfo';
import { LoginInfo } from './LoginInfo';
import { Text } from '@/components/Text';
import { BodyWrapper } from '@/components/ui/therapist/BodyWrapper';

export function Account() {
  const { user } = store.getState()?.signedInUser;

  const [activeSessions, setActiveSessions] = useState<Session[]>();

  useEffect(() => {
    getSessions().then((res) => {
      setActiveSessions(res);
    });
  }, []);

  if (!user) {
    return null;
  }

  return (
    <BodyWrapper>
      <View>
        <View>
          <Text style={{ fontSize: 42, fontWeight: 700 }}>Benutzerkonto</Text>
        </View>

        <Header user={user} />

        <PersonalInfo user={user} />
        <LoginInfo user={user} />

        <Card title="Angemeldete Geräte" styleBody={{ padding: 0 }}>
          <SessionsList sessions={activeSessions} usePadding={true} />
        </Card>

        <Management />
      </View>
    </BodyWrapper>
  );
}
